angular.module('impactx.list').directive('stSummary', function () {
    return {
        restrict: 'E',
        require: '^stTable',
        template: '{{size}}',
        link: function (scope, element, attr, ctrl) {
            scope.$watch(ctrl.getFilteredCollection, function (val) {
                scope.size = (val || []).length;
            })
        }
    }
});